import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { getFilterValues } from '../sbSharedRefineMenuHelpers';

// components
import { SbSharedRefineMenuMultiSelect } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelect';
import { SbSharedRefineMenuTypeaheadContainer } from '../SbSharedRefineMenuTypeahead/SbSharedRefineMenuTypeaheadContainer';

/* eslint-disable react/prop-types, react/display-name */

export const SbSharedRefineMenuMultiSelectSearchComponent = props => {
    const { viewer, values, searchBrowse, filterName } = props;
    const { appliedFilters } = searchBrowse;

    const appliedFilterValues = getFilterValues(appliedFilters, filterName);

    return (
        <SbSharedRefineMenuTypeaheadContainer
            appliedFilterValues={appliedFilterValues}
            filterName={filterName}
            availableFilterValues={values}
            viewer={viewer}
            searchBrowse={searchBrowse}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuMultiSelect
                    filterName={filterName}
                    appliedFilterValues={appliedFilterValues}
                    valuesToShow={valuesToShow}
                />
            )}
        </SbSharedRefineMenuTypeaheadContainer>
    );
};

SbSharedRefineMenuMultiSelectSearchComponent.propTypes = {
    values: PropTypes.array.isRequired,
    searchBrowse: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    filterName: PropTypes.string.isRequired,
};

export const SbSharedRefineMenuMultiSelectSearch = createFragmentContainer(
    SbSharedRefineMenuMultiSelectSearchComponent,
    {
        viewer: graphql`
            fragment SbSharedRefineMenuMultiSelectSearch_viewer on Viewer {
                ...SbSharedRefineMenuTypeaheadContainer_viewer
            }
        `,
        searchBrowse: graphql`
            fragment SbSharedRefineMenuMultiSelectSearch_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuTypeaheadContainer_searchBrowse
                appliedFilters {
                    name
                    localizedFilterName
                    canBeDismissed
                    values {
                        urlLabel
                        count
                        displayName
                    }
                }
            }
        `,
    }
);
